import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NoPreloading } from '@angular/router';
// import { PreloadAllModules } from '@angular/router';
// import { LoadMarkedPreloadStrategy } from './core/implements/loadMarked.preloadStrategy';

import { AuthService } from './core/services/auth.service';

/**
 * 路由配置:
 *
 * 备注:和LoadMarkedPreloadStrategy配合,在路由上设置 preload: true 使对应模块在首页加载完毕后加载
 * 该预加载策略主要考虑高频模块的加载不要延迟到路由跳转
 */
export const routes: Routes = [
    {
        path: '', redirectTo: 'home', pathMatch: 'full'
    },
    {
        path: 'manage', loadChildren: 'app/manage/manage.module#ManageModule',
        data: { title: '用户管理' }, canActivate: [AuthService]
    },
    {
        path: 'order', loadChildren: 'app/order/order.module#OrderModule',
        data: { title: '客户订单', preload: true }, canActivate: [AuthService]
    },
    {
        path: 'delivery', loadChildren: 'app/delivery/delivery.module#DeliveryModule',
        data: { title: '发货管理', preload: true }, canActivate: [AuthService]
    },
    {
        path: 'kpi', loadChildren: 'app/kpi/kpi.module#KpiModule',
        data: { title: '绩效管理' }, canActivate: [AuthService]
    },
    {
        path: 'vmi', loadChildren: 'app/vmi/vmi.module#VmiModule',
        data: { title: 'VMI管理' }, canActivate: [AuthService]
    },
    {
        path: 'statement', loadChildren: 'app/statement/statement.module#StatementModule',
        data: { title: '对账单' }, canActivate: [AuthService]
    },
    {
        path: 'sale-return', loadChildren: 'app/sale-return/sale-return.module#SaleReturnModule',
        data: { title: '退货管理', preload: true }, canActivate: [AuthService]
    },
    {
        path: 'price', loadChildren: 'app/price/price.module#PriceModule',
        data: { title: '报价管理', preload: true }
    },
    {
        path: 'wechat-check', loadChildren: 'app/wechat-check/wechat-check.module#WechatCheckModule',
        data: { title: '盘点', preload: true }
    },
    {
        path: 'demo', loadChildren: 'app/demo/demo.module#DemoModule',
        data: { title: 'demo' }, canActivate: [AuthService]
    },
    { path: '**', redirectTo: 'notfound' }
];

const routeConfig = {
    'useHash': true,
    // 'preloadingStrategy': LoadMarkedPreloadStrategy
    'preloadingStrategy': NoPreloading
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routeConfig)],
    exports: [RouterModule]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/app-routing.module.ts